<template>
    <a-modal :closable="false"
            :visible="isVisible"
    >
        <template #footer>
				<a-button @click="handleBtnCancel">
					Cancel
				</a-button>

				<a-button type="primary" @click="handleBtnSave" :loading="loading">
					Save
				</a-button>
			</template>

            <div>
                <a-form-model ref="categoryForm"  
						  	:model="category"
						  	:rules="categoryRules"
                >
                    <a-card :bordered="false" 
                            class="header-solid h-full" 
                            :bodyStyle="{paddingTop: 0, paddingBottom: '20px' }"
                    >
                        <a-row :gutter="[24]">
                            <a-form-model-item class="mb-10" 
												label="Category Name" 
												:colon="false"
												ref="categoryName"
												prop="categoryName"	   
							>
								<a-input allow-clear placeholder="eg. Minimal Bar Stool" 
												 	v-model="category.categoryName"
												 	@blur="() => { $refs.categoryName.onFieldBlur() }"
								/>
							</a-form-model-item>
                        </a-row>
                        <a-row :gutter="[24]">
                            <a-form-model-item class="mb-10" label="Description" :colon="false">
								<a-textarea v-model="category.description" :rows="2">
								</a-textarea>
							</a-form-model-item>
                        </a-row>
                    </a-card>
                </a-form-model>
            </div>
    </a-modal>
</template>

<script>
export default {
    data () {
        return {
            isVisible : false,
            loading : false,
            category : {
                categoryId : '',
                categoryName : '',
                description : ''
            },
            categoryRules : {
				categoryName : [
					{
						required : true,
						message : 'The field cannot be empty',
						trigger: 'blur'
					},
                    {
						min: 3,
						message : 'The field should have at least 3 characters',
						trigger: 'blur'
					}
                ]
            }
        }
    },
    methods : {

        handleBtnSave() {

            this.$refs.categoryForm.validate(async valid => {
                if (valid) {
                    this.loading = true;
                    let payload = {
                        categoryId : this.category.categoryId,
                        name : this.category.categoryName,
                        description : this.category.description
                    }
                    await this.$store.dispatch('categories/updateCategoryAction', payload);
                    await this.sleep(1000);
                    this.loading = false;
                    this.clear();
                    this.isVisible = false;
                    
                }
            });
            
        },

        handleBtnCancel() {
            this.clear();
            this.isVisible = false;
        },

        showModal(category) {
            this.category.categoryId = category.categoryId;
            this.category.categoryName = category.name,
            this.category.description = category.description
            this.isVisible = true;

        },

        clear() {
            this.category.categoryName = '';
            this.category.description = '';
            this.category.categoryId = '';
        },

        async sleep(miliSeconds) {
            return new Promise(r => setTimeout(r, miliSeconds));
        },


    }
}
</script>

<style>

</style>